import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LinePlayIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M18.54 9 8.88 3.46a3.42 3.42 0 0 0-5.13 3v11.12A3.42 3.42 0 0 0 7.17 21a3.4294 3.4294 0 0 0 1.71-.46L18.54 15a3.4201 3.4201 0 0 0 0-5.92V9Zm-1 4.19-9.66 5.62a1.44 1.44 0 0 1-1.42 0 1.4207 1.4207 0 0 1-.71-1.23V6.42a1.42 1.42 0 0 1 .71-1.23A1.51 1.51 0 0 1 7.17 5a1.54 1.54 0 0 1 .71.19l9.66 5.58a1.4198 1.4198 0 0 1 .52 1.9402 1.4198 1.4198 0 0 1-.52.5198v-.04Z"/>
  </SvgIcon>
}

export default LinePlayIcon
